import { Component } from 'react';

import Dropdown from '../../components/ui/dropdown/dropdown';
import FeaturesTilesComponent from '../../components/ui/features-tiles/features-tiles.component';
import { MotiveComponent } from '../../components/ui/motive/motive.component';
import Tooltip from '../../components/ui/tooltip/tooltip.component';
import { IOC_TYPES } from '../../context/ioc.types';
import { lazyInject } from '../../context/module';
import { FileUpload } from '../../models/file-upload';
import { Logger } from '../../models/logger';
import { UploadInProgressFile, UploadInProgressFileFactory } from '../../models/upload-in-progress-file';
import { FileDownloadService } from '../../services/file-download.service';
import { FileShareService } from '../../services/file-share.service';
import { FileUploadService } from '../../services/file-upload.service';
import { MemeUploadService } from '../../services/meme-upload.service';
import { MotivesService } from '../../services/motives.service';
import { PageDataProviderService } from '../../services/page-data-provider.service';
import { ProcessorResolverService } from '../../services/processor-resolver.service';
import { ScriptLoadService } from '../../services/script-load.service';
import { SpinnerService } from '../../services/spinner.service';
import { UIContext } from '../../services/ui-context';
import { UploadedFilesService } from '../../services/uploaded-files.service';
import { WebSocketService } from '../../services/websocket.service';
import { MouseEventTypes } from '../../types/geo.types';
import { RouteProps, SeoFeature } from '../../types/route-types';
import { FromTypes, OperationTypes, OriginalInputFile, ProcessTypes } from '../../types/types';
import { UIUtils } from '../../utils/dom-utils';
import { FileUploadUtils } from '../../utils/file-upoad.utils';
import { IconHelper } from '../../utils/icon-helper';
import { HtmlEntityTypes } from '../../utils/icon.utils';
import { reloadAfterExecute, reloadAfterExecuteAsync } from '../../utils/react.utils';
import { MotiveLocationTypes } from '../../utils/request.utils';
import { WindowUtils } from '../../utils/window.utils';
import { cloneDeep, parseInt, range } from '../../utils/lodash-min';
import { FloatingSVGGraphic } from './clip-art';
import { ClipartSourceImage } from './clipart-source-image';
import { Meme } from './meme-generator';
import styles from './meme-generator.component.module.scss';
import { MemeSpaceImage, MemeStoredImage } from './meme-image';
import { MemeSourceImage } from './meme-source-image';
import { MemeText } from './meme-text';
import { Location, TextAlignType, TextAlignTypes } from './meme.types';
import { MemeShareModalComponent } from './share/meme-share-modal.component';
import { ClipartModalComponent } from './templates/clipart-modal.component';
import { MemeModalComponent } from './templates/meme-modal.component';



export default class MemeGeneratorComponent extends Component<RouteProps> {
    private readonly logger = Logger.getLogger('MemeGeneratorComponent');

    public title: string;
    public description: string;
    public features: Array<SeoFeature>;

    public memeWidth = 700;

    public showHTML = false;
    public controllersShown = true;
    public isMobile: boolean;
    public fileUploadArray: FileUpload[];

    meme: Meme;

    private selectedItem: any;
    private selectedItemTopLeftOffset: Location;
    private isResizeHandlerActive = false;
    private resizeHandlerType: MouseEventTypes.MouseEventType;

    public drawerType = undefined;

    private colorsDropdownItems = [
        { id: 'white', item: 'white', text: 'White', selected: false },
        { id: 'black', item: 'black', text: 'Black', selected: true },
        { id: 'red', item: 'red', text: 'Red', selected: false },
        { id: 'green', item: 'green', text: 'Green', selected: false },
        { id: 'blue', item: 'blue', text: 'Blue', selected: false },
        { id: 'yellow', item: 'yellow', text: 'Yellow', selected: false },
        { id: 'orange', item: 'orange', text: 'Orange', selected: false },
        { id: 'pink', item: 'pink', text: 'Pink', selected: false },
        { id: 'purple', item: 'purple', text: 'Purple', selected: false },
    ]
    private fontsDropdownItems = [
        { item: 'impact', id: 'impact', text: 'Impact (meme)', selected: true },
        { item: 'arial', id: 'arial', text: 'Arial', selected: false },
        { item: 'helvetica', id: 'helvetica', text: 'Helvetica', selected: false },
        { item: 'verdana', id: 'verdana', text: 'verdana', selected: false },
        { item: 'tahoma', id: 'tahoma', text: 'Tahoma', selected: false },
        { item: 'georgia', id: 'georgia', text: 'Georgia', selected: false },
        { item: 'Times New Roman', id: 'Times New Roman', text: 'Times New Roman', selected: false },
    ];

    private dropdownItemsCache = new Map();

    mouseMoveHandler: ($event) => void;
    addImagePanelShowForImage = null;
    borderPropertyPanelShownForImage = null;


    @lazyInject(IOC_TYPES.UploadedFilesService) private uploadedFilesService: UploadedFilesService;
    @lazyInject(IOC_TYPES.FileUploadService) private fileUploadService: FileUploadService;
    @lazyInject(IOC_TYPES.MemeUploadService) private memeUploadService: MemeUploadService;
    @lazyInject(IOC_TYPES.UIContext) private uiContext: UIContext;
    @lazyInject(IOC_TYPES.FileDownloadService) private fileDownloadService: FileDownloadService;
    @lazyInject(IOC_TYPES.FileShareService) private fileShareService: FileShareService;
    @lazyInject(IOC_TYPES.ProcessorResolverService) private processorResolverService: ProcessorResolverService;
    @lazyInject(IOC_TYPES.WebSocketService) private websocketService: WebSocketService;
    @lazyInject(IOC_TYPES.MotivesService) public motiveService: MotivesService;
    @lazyInject(IOC_TYPES.SpinnerService) private spinner: SpinnerService;
    @lazyInject(IOC_TYPES.ScriptLoadService) private scriptLoadService: ScriptLoadService;
    @lazyInject(IOC_TYPES.PageDataProviderService) private pageDataProviderService: PageDataProviderService;

    constructor(props: RouteProps) {
        super(props);
    }

    componentDidMount() {
        const value = this.props.pageData;
        this.features = value.page_seo.feature;
        this.title = value.page_seo.title;
        this.description = value.page_seo.description && value.page_seo.description.replace(/\s+/g, ' ');
        this.uploadedFilesService.initializeForCompatibility(value.fromType, value.accept);
        this.uploadedFilesService.notyfyAll();
        if (window.screen.width < 600) {
            setTimeout(() => {
                this.memeWidth = 300;
            }, 10);
        }
        this.initializeMemeSample();
    }

    @reloadAfterExecute()
    clearMeme() {
        this.meme = new Meme(this.memeWidth);
        const memeImage1 = new MemeStoredImage('/meme/src/placeholder.jpg', this.meme);

        Promise.all([this.meme.addImage(memeImage1)]).then(() => {
            this.meme.paint();
        });
    }

    @reloadAfterExecute()
    updateTextColor(memeText: MemeText, color: string) {
        memeText.fontColor = color;
        this.meme.paint();
    }

    @reloadAfterExecute()
    updateTextFamily(memeText: MemeText, fontFamily: string) {
        memeText.fontFamily = fontFamily;
        this.meme.paint();
    }

    @reloadAfterExecute()
    addNewText() {
        const text = new MemeText(
            `Double click for text editor.\n ...`,
            {
                width: this.memeWidth,
                x: 0,
                y: 100,
                z: 1,
            });

        this.meme.addText(text);
        this.meme.paint();
    }

    @reloadAfterExecute()
    addClipArt() {
        ClipartModalComponent.show({
            selectCallback: (memeSourceImage: ClipartSourceImage) => {
                FloatingSVGGraphic.createNew({
                    width: this.memeWidth,
                    x: 0,
                    y: 100,
                    z: 1,
                }, memeSourceImage.sourceImageUrl).then(graphic => {
                    this.meme.addGraphic(graphic);
                    this.meme.paint();
                });
                this.forceUpdate();
            },
        });
    }

    @reloadAfterExecute()
    toggleControls() {
        this.controllersShown = !this.controllersShown;
    }

    @reloadAfterExecute()
    changeImage(image: MemeStoredImage) {
        MemeModalComponent.show({
            selectCallback: (memeSourceImage: MemeSourceImage) => {
                this.meme.changeImageSrc(image, memeSourceImage.sourceImageUrl)
                    .then(() => {
                        //
                        this.forceUpdate();
                    });
            },
        });
    }

    @reloadAfterExecute()
    addImageAbove(image: MemeStoredImage) {
        MemeModalComponent.show({
            selectCallback: (memeSourceImage: MemeSourceImage) => {
                this.meme.addImageAbove(image, new MemeStoredImage(memeSourceImage.sourceImageUrl, this.meme))
                    .then(() => {
                        //
                        this.forceUpdate();
                    });
            },
        });
    }

    @reloadAfterExecute()
    addSpaceAbove(image: MemeStoredImage) {
        this.meme.addImageAbove(image, new MemeSpaceImage(this.meme, { width: this.memeWidth, height: 100 }, 'black'))
            .then(() => {
                //
                this.forceUpdate();
            });
    }

    @reloadAfterExecute()
    addImageBelow(image: MemeStoredImage) {
        MemeModalComponent.show({
            selectCallback: (memeSourceImage: MemeSourceImage) => {
                this.meme.addImageBelow(image, new MemeStoredImage(memeSourceImage.sourceImageUrl, this.meme))
                    .then(() => {
                        //
                        this.forceUpdate();
                    });
            },
        });
    }

    uploadCustomImage() {
        //
    }

    @reloadAfterExecute()
    updateImageBorderColor(image: MemeStoredImage, color) {
        image.setBackgroundColor(color);
        this.meme.paint();
    }

    @reloadAfterExecute()
    updateImageBorderTop(event: any, image: MemeStoredImage) {
        //
        image.setBorderTop(parseInt(event.target.value, 10));
        this.meme.paint();
    }

    @reloadAfterExecute()
    updateImageBorderBottom(event: any, image: MemeStoredImage) {
        //
        image.setBorderBottom(parseInt(event.target.value, 10));
        this.meme.paint();
    }

    @reloadAfterExecute()
    moveImageDown(image) {
        this.meme.swapWithBelow(image);
        this.meme.paint();
    }

    @reloadAfterExecute()
    moveImageUp(image) {
        this.meme.swapWithAbove(image);
        this.meme.paint();
    }

    @reloadAfterExecute()
    deleteImage(image) {
        try {
            this.meme.deleteImage(image);
        } catch (e) {
            this.uiContext.showErrorDialog(
                { title: 'Error', text: 'Can not delete this image. Meme should have at least one image. You may change the image.' });
        }
    }

    @reloadAfterExecute()
    updateTextAlign(memeText: MemeText, textAlign: TextAlignType) {
        memeText.textAlign = textAlign;
        this.meme.paint();
    }

    @reloadAfterExecute()
    deleteText(text) {
        this.meme.deleteText(text);
        this.meme.paint();
    }

    @reloadAfterExecute()
    deleteGraphic(graphic) {
        this.meme.deleteGraphic(graphic);
        this.meme.paint();
    }

    @reloadAfterExecute()
    capitalizeText(text: MemeText) {
        text.setCapitalized(!text.getCapitalized());
        this.meme.paint();
    }

    @reloadAfterExecute()
    toggleLineWidth(text: MemeText) {
        text.hasLineWidth = !text.hasLineWidth;
        this.meme.paint();
    }

    @reloadAfterExecute()
    showDrawerFor(type: string) {
        this.drawerType = type;
    }

    @reloadAfterExecute()
    fontPropertyChanged(event: any, memeText: MemeText) {
        if (this.drawerType === 'FONT_SIZE') {
            memeText.setMaxFontSize(event.target.value);
            this.meme.paint();
        } else if (this.drawerType === 'FONT_GAP') {
            memeText.setFontGap(event.target.value);
            this.meme.paint();
        }
    }

    @reloadAfterExecute()
    contentChanged(event: KeyboardEvent, text: MemeText) {
        const textArea = event.target as HTMLTextAreaElement;
        // PSLogger.log(event);
        text.setText(textArea.value);
        this.meme.paint();
    }

    shouldIgnoreEvent(event: MouseEvent) {
        return UIUtils.hasParentWithCSSSelector(event.target as HTMLElement, '.text-editor,.static-handler');
    }

    @reloadAfterExecute()
    mouseDown(event: MouseEvent, item: any, type: MouseEventTypes.MouseEventType) {
        if (this.shouldIgnoreEvent(event)) {
            return;
        }
        const elRect: ClientRect = (event.target as HTMLElement).getBoundingClientRect();
        const ev = ((event as any).touches && (event as any).touches[0]) || event;
        const p: Location = {
            x: elRect.left - ev.clientX,
            y: elRect.top - ev.clientY,
        };
        this.isResizeHandlerActive = true;
        this.selectedItem = item;
        this.resizeHandlerType = type;
        this.selectedItemTopLeftOffset = p;
        this.meme.setSelectedItem(item, p);
        event.preventDefault();
        if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
        }
        if (event.stopPropagation) {
            event.stopPropagation();
        }

        WindowUtils.addMoveMoveHandlerToWindow(($event) => this.mouseMove($event));
        WindowUtils.addMoveUpHandlerToWindow(($event) => this.mouseUp());
    }

    suppressEvent(event: MouseEvent) {
        event.preventDefault();
        if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
        }
        if (event.stopPropagation) {
            event.stopPropagation();
        }
    }

    @reloadAfterExecute()
    mouseMove(event) {
        const ev = ((event as any).touches && (event as any).touches[0]) || event;
        if (this.isResizeHandlerActive && this.selectedItem) {
            const clientX = ev.clientX;
            const clientY = ev.clientY;
            if (this.resizeHandlerType === MouseEventTypes.RESIZE) {
                this.meme.resizeGraphicContainer(this.selectedItem, {
                    x: clientX,
                    y: clientY,
                });
            } else if (this.resizeHandlerType === MouseEventTypes.MOVE) {
                this.meme.moveGraphicContainer(this.selectedItem, {
                    x: clientX,
                    y: clientY,
                });
            } else if (this.resizeHandlerType === MouseEventTypes.ROTATE) {
                this.meme.rotateGraphicContainer(this.selectedItem, {
                    x: clientX,
                    y: clientY,
                });
            } else {
                this.logger.error({ message: 'Unknown event.' });
            }
            this.meme.paint();
        }
    }

    @reloadAfterExecute()
    updateEditMode($event, text: MemeText) {
        const state = text.getEditPanelState();
        this.meme.hideAllTextEditPanels();
        text.toggleEditPanel();
        if (state) {
            text.hideEditPanel();
        } else {
            text.showEditPanel();
        }
    }

    @reloadAfterExecute()
    mouseUp() {
        this.isResizeHandlerActive = false;
        this.selectedItem = undefined;
        this.meme.setSelectedItem(undefined, undefined);
    }

    /**
     * if call on keydown this will return the previous cursor position.
     * for keyup, this returns current position
     * @param editableDiv
     */
    getCaretPosition(editableDiv) {
        let caretPos = 0,
            sel, range;
        if (window.getSelection) {
            sel = window.getSelection();
            if (sel.rangeCount) {
                range = sel.getRangeAt(0);
                if (range.commonAncestorContainer.parentNode === editableDiv) {
                    caretPos = range.endOffset;
                }
            }
        } else if ((document as any).selection && (document as any).selection.createRange) {
            range = (document as any).selection.createRange();
            if (range.parentElement() === editableDiv) {
                const tempEl = document.createElement('span');
                editableDiv.insertBefore(tempEl, editableDiv.firstChild);
                const tempRange = range.duplicate();
                tempRange.moveToElementText(tempEl);
                tempRange.setEndPoint('EndToEnd', range);
                caretPos = tempRange.text.length;
            }
        }
        return caretPos;
    }

    async shareMeme() {
        await this.initializeScriptsAndWebsockets();
        const fileUpload = await this.uploadMeme();
        const inputFileLocation = fileUpload.originalInputFiles[0].location;
        this.fileShareService.shareGCSPermenentFile(fileUpload, inputFileLocation, 'meme.jpg', true)
            .then(data => {
                MemeShareModalComponent.show({
                    url: data.pageUrl,
                    downlaodFile: (title) => {
                        this.fileShareService.downloadMemeImageFile(data.imgUrl);
                    },
                });
            });
    }

    async downloadMeme() {
        await this.initializeScriptsAndWebsockets();
        try {
            const fileUpload = await this.uploadMeme();
            const inputFileLocation = fileUpload.originalInputFiles[0].location;
            this.fileDownloadService.downloadFileInputFile(fileUpload, inputFileLocation);
        } catch (e) {
            this.uiContext.handleError(e);
        }
    }

    private async uploadMeme(): Promise<FileUpload> {
        await this.initializeScriptsAndWebsockets();
        try {
            this.uiContext.successToast('Please wait wile we upload your meme.', '', 10000);
            const file = this.memeUploadService.canvastoFile(this.meme.getCanvasManager().getCanvas());
            const uniqueProcessType = (await this.pageDataProviderService.loadFeaturePageDataForProps(this.props).toPromise()).uniqueProcessType;
            const metadata = await this.processorResolverService.generateFileUploadRequestMetadata(file, ['image'], 'image', OperationTypes.UPLOAD);
            const fileWithMetadata = await UploadInProgressFileFactory.newUploadInProgressFile(
                file,
                metadata,
                uniqueProcessType,
            );
            const observerObject = {
                next: x => {
                    fileWithMetadata.setProgress(x);
                    // fileUpload.progress = x;
                },
                error: err => {
                    this.logger.error({ message: 'Error uploading meme.', error: err });
                    fileWithMetadata.setError();
                },
                complete: () => {
                    fileWithMetadata.setComplete();
                },
            };

            await this.fileUploadService.uploadFileFromLocalDisk(fileWithMetadata, observerObject)
                .then((originalInputFile: OriginalInputFile) => {
                    fileWithMetadata.setResponse(originalInputFile);
                });
            const fileUpload = FileUploadUtils.toFileUpload(
                fileWithMetadata,
                this.websocketService.getId(),
                ProcessTypes.MEME,
                [FromTypes.IMAGE],
                'image',
                {},
                {} as any,
                'meme-generator',
            );
            return fileUpload;
        } catch (e) {
            throw e;
        }
    }

    async initializeScriptsAndWebsockets() {
        await this.spinner.runWithLoader(async () => {
            try {
                await this.scriptLoadService.loadAllScriptsIfNotLoaded();
            } catch (e) {
                this.logger.error({
                    error: e,
                    message: 'Something went wrong while loading scripts.',
                });
                this.uiContext.showErrorDialog(
                    {
                        title: 'Failed to initialize services!', text: 'Following services failed: ' +
                            this.scriptLoadService.getFailedScripts().join(', ') +
                            '. Please send us a screenshot to (support@xconvert.com).' +
                            ' Please try loading the page on Incognito Mode with plugins disabled.'
                    },
                );
            }
        }, 'Please wait while we initialize file upload service...');
    }

    @reloadAfterExecuteAsync()
    private async initializeMemeSample() {
        this.meme = new Meme(this.memeWidth);
        const memeImage1 = new MemeStoredImage('/meme/src/Batman-Slapping-Robin.jpg', this.meme);
        const texts = [
            {
                TYPE: 'MemeText',
                maxMaxFontSize: 40,
                fontSize: 30,
                fontGap: 15,
                hasLineWidth: false,
                fontColor: 'black',
                fontFamily: 'tahoma',
                textAlign: 'center',
                editPanelShown: false,
                capitalized: false,
                topOffset: 5,
                text: 'You can add more text \n like this by clicking on\n "Text" button on top',
                textLocation: {
                    width: 335,
                    x: 13,
                    y: 99.99998474121094,
                    z: 1,
                },
                id: 'x-9c10b010-a7bb-4b46-8bf9-41f313a88ce0',
                boundingRectangle: {
                    x: 13,
                    y: 99.99998474121094,
                    width: 335,
                    height: 130,
                },
            }, {
                TYPE: 'MemeText',
                maxMaxFontSize: 40,
                fontSize: 24,
                fontGap: 15,
                hasLineWidth: false,
                fontColor: 'black',
                fontFamily: 'verdana',
                textAlign: 'center',
                editPanelShown: false,
                capitalized: false,
                topOffset: 5,
                text: 'You can change/add\n more images by clicking on \n"+ Image" button...',
                textLocation: {
                    width: 306,
                    x: 380,
                    y: 111.99998474121094,
                    z: 1,
                },
                id: 'x-c14677fb-3997-42a0-b463-ae26f5994e42',
                boundingRectangle: {
                    x: 380,
                    y: 111.99998474121094,
                    width: 306,
                    height: 112,
                },
            }, {
                TYPE: 'MemeText',
                maxMaxFontSize: 40,
                fontSize: 31,
                fontGap: 15,
                hasLineWidth: true,
                fontColor: 'white',
                fontFamily: 'impact',
                textAlign: 'center',
                editPanelShown: false,
                capitalized: true,
                topOffset: 5,
                text: 'Funny Meme Title added to space above\nDouble click to edit...',
                textLocation: {
                    width: 700,
                    x: 4,
                    y: 1.993743896484375,
                    z: 1,
                },
                id: 'x-3e86288e-561e-44cf-8f0e-6dc94997997e',
                boundingRectangle: {
                    x: 4,
                    y: 1.993743896484375,
                    width: 700,
                    height: 87,
                },
            }];
        await Promise.all([this.meme.addImage(memeImage1)])
            .then(() => {
                const text = new MemeText(
                    `Double click for text editor.\n ...`,
                    { width: this.memeWidth, x: 0, y: 20, z: 1 },
                );
                Object.assign(text, texts[0]);
                this.meme.addText(text);

                const text2 = new MemeText(
                    `Double click for text editor.\n ...`,
                    { width: this.memeWidth, x: 0, y: 20, z: 1 },
                );
                Object.assign(text2, texts[1]);
                this.meme.addText(text2);

                const text3 = new MemeText(
                    `Double click for text editor.\n ...`,
                    { width: this.memeWidth, x: 0, y: 20, z: 1 },
                );
                Object.assign(text3, texts[2]);
                this.meme.addText(text3);

                const imageRewite = {
                    'loaded': true,
                    'border': { 'top': 93, 'bottom': 0 },
                    'bgColor': 'black',
                    'srcUrl': '/meme/src/Batman-Slapping-Robin.jpg',
                    'id': 'x-fbd80572-7ebd-4364-b844-605f9f5b9a66',
                    'boundingRectangle': { 'x': 0, 'y': 0, 'width': 700, 'height': 770.25 },
                };

                Object.assign(this.meme.images[0], imageRewite);

                this.meme.paint();
            });
        console.log(this.meme);
    }

    @reloadAfterExecute()
    toggleAddImagePanelFor(image) {
        this.addImagePanelShowForImage = this.addImagePanelShowForImage ? null : image;
    }

    getAddImagePanel(image) {
        return <div className={styles['meme-action-panel']}>
            <button type="button" className="btn btn-sm btn-secondary btn-sm"
                onClick={() => { this.addImageAbove(image) }}>
                {IconHelper.getIconElement(HtmlEntityTypes.PLUS_BOLD)}
                Image Above
            </button>
            <button type="button" className="btn btn-sm btn-secondary btn-sm"
                onClick={() => { this.changeImage(image) }}>
                Change Image
            </button>
            <button type="button" className="btn btn-sm btn-secondary btn-sm"
                onClick={() => { this.addImageBelow(image) }}>
                {IconHelper.getIconElement(HtmlEntityTypes.PLUS_BOLD)}
                Image Below
            </button>
        </div>
    }

    @reloadAfterExecute()
    toggleBorderPropertyPanelFor(image) {
        this.borderPropertyPanelShownForImage = this.borderPropertyPanelShownForImage ? null : image;
    }

    getBorderPropertyPanelFor(image) {
        return <div className={styles['meme-action-panel']}>
            <div className="form-group">
                <label htmlFor="formControlRange">Border Color</label>
                <Dropdown
                    // btnClass="btn btn-secondary"
                    label=" Border Color"
                    initialValue={this.colorsDropdownItems.find(a => a.selected)}
                    values={this.colorsDropdownItems}
                    onSelect={($event) => this.updateImageBorderColor(image, $event.item)}
                    valueFormatter={(v: any) => v && v.text}
                    hasTooltip={(v) => false}
                    getTooltip={(v) => null}
                ></Dropdown>
            </div>

            <div className="form-group">
                <label htmlFor="formControlRange">Space Up</label>
                <input type="range" className="form-control-range" id="formControlRange"
                    onInput={($event) => this.updateImageBorderTop($event, image)}
                    value={image.getBorder().top} min="0" max="1000" />
            </div>
            <div className="form-group">
                <label htmlFor="formControlRange">Space Down</label>
                <input type="range" className="form-control-range" id="formControlRange"
                    onInput={($event) => this.updateImageBorderBottom($event, image)}
                    value={image.getBorder().bottom} min="0" max="1000" />
            </div>
        </div>;
    }

    render() {
        return <div>
            <div className="gcontent-container">
                <MotiveComponent
                    data="8711788873"
                    location={MotiveLocationTypes.memePageTop} containerWidth="100%"
                    containerHeight="60px"
                    adWidth="970px" adHeight="90px" showAds={true} className='width_major'
                ></MotiveComponent>
            </div>
            <div className="row nav-padding">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 page-heading mb-3 text-center">
                    <div className={styles.title}><b>{this.title}</b></div>
                    <div className={`${styles.description} secondary-text`}>{this.description}</div>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-3">
                    <div className={styles.title}>Where to find and download more meme images to use here? try https://knowyourmeme.com/memes/
                    </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 action-menu">
                    <Tooltip text="Add New Text">
                        <button type="button" className="btn btn-sm btn-secondary mb-2 ml-1" onClick={() => this.addNewText()}>
                            + Text
                        </button>
                    </Tooltip>

                    <Tooltip text="Add Clipart">
                        <button type="button" className="btn btn-sm btn-secondary mb-2 ml-1" onClick={() => this.addClipArt()} >
                            + Clipart
                        </button>
                    </Tooltip>
                    <Tooltip text="Toggle Controllers">
                        <button type="button" className="btn btn-sm btn-secondary mb-2 ml-1" onClick={() => this.toggleControls()}>
                            {
                                (!this.controllersShown && <span>Show</span>) || <span>Hide</span>
                            } Preview
                        </button>
                    </Tooltip>
                    <Tooltip text="Share Meme">
                        <button type="button" className="btn btn-sm btn-primary mb-2 ml-1" onClick={() => this.shareMeme()} >
                            Share
                        </button>
                    </Tooltip>
                    <Tooltip text="Download Meme">
                        <button type="button" className="btn btn-sm btn-success mb-2 ml-1" onClick={() => this.downloadMeme()} >
                            Download
                        </button>
                    </Tooltip>
                    <Tooltip text="Clear Meme">
                        <button type="button" className="btn btn-danger btn-sm float-right  mb-2 ml-1" onClick={() => this.clearMeme()} >
                            Clear Meme
                        </button>
                    </Tooltip>
                </div>
                <div className="hidden-xs hidden-sm hidden-md col-lg-1"></div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10">
                    <div className={`canvas-container ${styles['canvas-container']}`}>
                        <canvas id="canvas"></canvas>
                        {
                            (this.meme ? this.meme.getSortedGraphics('ClipArt') : []).map((graphic: any) => {
                                return <div
                                    key={graphic.id}
                                    id={graphic.id}
                                    className={`${styles['graphc-container']} ${styles['graphic-container-parent']} ${!this.controllersShown ? styles["container-invisible"] : ''}`}
                                    style={{
                                        width: graphic.boundingRectangle.width,
                                        height: graphic.boundingRectangle.height,
                                        left: graphic.getLocation().x,
                                        top: graphic.getLocation().y,
                                    }}
                                >

                                    <div className={styles['container-event-handler']} onMouseDown={($event) => this.mouseDown($event as any, graphic, MouseEventTypes.MOVE)}

                                        onTouchStart={($event: any) => this.mouseDown($event, graphic, MouseEventTypes.MOVE)}
                                        onDoubleClick={($event) => this.updateEditMode($event, graphic)}></div>

                                    <div
                                        className={`${styles['handler']} ${styles['resize-handler']} ${!this.controllersShown ? styles['control-hidden'] : ''}`}
                                        id={'rh' + graphic.id}
                                        onMouseDown={($event) => this.mouseDown($event as any, graphic, MouseEventTypes.RESIZE)}
                                        onTouchStart={($event: any) => this.mouseDown($event, graphic, MouseEventTypes.RESIZE)}

                                    >
                                        {IconHelper.getIconElement(HtmlEntityTypes.ARROW_LEFT_RIGHT)}

                                    </div>

                                    <div
                                        id={'dt' + graphic.id}
                                        className={`${styles['handler']} ${styles['delete-text static-handler']} ${!this.controllersShown ? styles['control-hidden'] : ''}`}
                                        onClick={($event) => this.deleteGraphic(graphic)} >
                                        {IconHelper.getIconElement(HtmlEntityTypes.PENSIL)}
                                    </div>

                                    <div
                                        className={`rotate-handler hidden-feature ${styles['rotate-handler']} ${styles['hidden-feature']}`}
                                        onClick={($event) => this.suppressEvent($event as any)}
                                        onMouseDown={($event) => this.mouseDown($event as any, graphic, MouseEventTypes.ROTATE)}
                                    >
                                        {IconHelper.getIconElement(HtmlEntityTypes.UNDO)}
                                    </div>

                                </div>
                            })
                        }

                        {
                            (this.meme ? this.meme.getSortedGraphics('MemeText') : []).map((text: any) => {
                                let colorsDropdownItems = this.dropdownItemsCache.get('fontColor' + text.id);
                                let fontsDropdownItems = this.dropdownItemsCache.get('fontFamily' + text.id);
                                if (!colorsDropdownItems) {
                                    colorsDropdownItems = cloneDeep(this.colorsDropdownItems);
                                    this.dropdownItemsCache.set('fontColor' + text.id, colorsDropdownItems);
                                }
                                if (!fontsDropdownItems) {
                                    fontsDropdownItems = cloneDeep(this.fontsDropdownItems);
                                    this.dropdownItemsCache.set('fontFamily' + text.id, fontsDropdownItems);
                                }
                                colorsDropdownItems.forEach(i => { i.selected = i.item === text.fontColor });
                                fontsDropdownItems.forEach(i => { i.selected = i.item === text.fontFamily });

                                return <div
                                    id={text.id}
                                    key={text.id}
                                    className={`${styles['graphc-container']} ${styles['text-container-parent']} 
                                        ${!this.controllersShown ? styles["container-invisible"] : ''}
                                        ${text.editPanelShown ? styles["editor-shown"] : ''}
                                        `}
                                    style={{
                                        width: text.boundingRectangle.width,
                                        height: text.boundingRectangle.height,
                                        left: text.getLocation().x,
                                        top: text.getLocation().y,
                                    }}
                                >

                                    <div className={styles['container-event-handler']} onMouseDown={($event) => this.mouseDown($event as any, text, MouseEventTypes.MOVE)}

                                        onTouchStart={($event: any) => this.mouseDown($event, text, MouseEventTypes.MOVE)}
                                        onDoubleClick={($event) => this.updateEditMode($event, text)}></div>

                                    <div style={{ bottom: text.boundingRectangle.height }}
                                        className={`${styles['level100']} ${styles['text-editor']} ${!text.editPanelShown ? "hidden" : ''} ${!this.controllersShown ? styles["control-hidden"] : ''}`}
                                    >
                                        <div className={`${styles['editor-panel']} mb-1`}>
                                            <span onClick={() => this.toggleLineWidth(text)}
                                                className={`badge ${text.hasLineWidth ? "badge-primary" : ''} ${!text.hasLineWidth ? "badge-secondary" : ''}`}
                                            >Text Strock</span>
                                            <span onClick={() => this.capitalizeText(text)}
                                                className={`badge ${text.getCapitalized() ? "badge-primary" : ''} ${!text.getCapitalized() ? "badge-secondary" : ''}`}
                                            >Capitalize</span>
                                            <span className="badge badge-danger" onClick={() => this.deleteText(text)}>Delete Text</span>
                                            <span className="badge badge-secondary" onClick={($event) => this.updateEditMode($event, text)}>
                                                {IconHelper.getIconElement(HtmlEntityTypes.X_BOLD)}
                                            </span>
                                        </div>
                                        <div className={`${styles['text-editor-content']} mb-1`}>
                                            <div className="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" className="btn btn-sm btn-secondary"
                                                    onClick={($event) => this.updateTextAlign(text, TextAlignTypes.LEFT)}>
                                                    left
                                                </button>
                                                <button type="button" className="btn btn-sm btn-secondary"
                                                    onClick={($event) => this.updateTextAlign(text, TextAlignTypes.CENTER)}>
                                                    center
                                                </button>
                                                <button type="button" className="btn btn-sm btn-secondary"
                                                    onClick={($event) => this.updateTextAlign(text, TextAlignTypes.RIGHT)}>
                                                    right
                                                </button>
                                            </div>
                                            <Dropdown
                                                // btnClass="btn btn-secondary"
                                                label="Text Color"
                                                initialValue={colorsDropdownItems.find(a => a.selected)}
                                                values={colorsDropdownItems}
                                                onSelect={($event) => this.updateTextColor(text, $event.item)}
                                                valueFormatter={(v: any) => v && v.text}
                                                hasTooltip={(v) => false}
                                                getTooltip={(v) => null}
                                            ></Dropdown>


                                            <Dropdown
                                                // btnClass="btn btn-secondary"
                                                label="Font Family"
                                                initialValue={fontsDropdownItems.find(a => a.selected)}
                                                values={fontsDropdownItems}
                                                onSelect={($event) => this.updateTextFamily(text, $event.item)}
                                                valueFormatter={(v: any) => v && v.text}
                                                hasTooltip={(v) => false}
                                                getTooltip={(v) => null}
                                            ></Dropdown>

                                            <div className="btn-group" role="group">
                                                <button type="button" className="btn btn-sm btn-secondary" onClick={($event) => this.showDrawerFor('FONT_SIZE')}>
                                                    Font Size
                                                </button>
                                            </div>
                                            <div className="btn-group" role="group">
                                                <button type="button" className="btn btn-sm btn-secondary" onClick={($event) => this.showDrawerFor('FONT_GAP')}>
                                                    Font Gap
                                                </button>
                                            </div>
                                        </div>
                                        <div className="mb-1">
                                            {
                                                this.drawerType && <div className="form-group">
                                                    <label htmlFor="formControlRange">{this.drawerType === 'FONT_SIZE' ? 'Font Size' : 'Font Gap'}:
                                                        {this.drawerType === 'FONT_SIZE' ? text.getMaxFontSize() : text.getFontGap()}</label>
                                                    <input type="range" className="form-control-range" id="formControlRange"
                                                        onInput={($event) => this.fontPropertyChanged($event, text)}
                                                        value={this.drawerType === 'FONT_SIZE' ? text.getMaxFontSize() : text.getFontGap()} />
                                                </div>
                                            }

                                        </div>
                                        <textarea onKeyUp={($event) => this.contentChanged($event as any, text)}>{text.text}</textarea>

                                    </div>
                                    <div
                                        className={`${styles['handler']} ${styles['resize-handler']} ${!this.controllersShown ? styles["control-hidden"] : ''}`}
                                        id={'rh' + text.id}
                                        onMouseDown={($event) => this.mouseDown($event as any, text, MouseEventTypes.RESIZE)}
                                        onTouchStart={($event: any) => this.mouseDown($event, text, MouseEventTypes.RESIZE)}


                                    >
                                        {IconHelper.getIconElement(HtmlEntityTypes.ARROW_LEFT_RIGHT)}
                                    </div>

                                    <div
                                        id={'te' + text.id}
                                        className={`${styles['handler']} ${styles['toggle-edit']} ${styles['static-handler']} ${!this.controllersShown ? styles["control-hidden"] : ''} ${!text.editPanelShown ? styles["selected"] : ''}`}
                                        onClick={($event) => this.updateEditMode($event, text)}
                                    >

                                        {IconHelper.getIconElement(HtmlEntityTypes.PENSIL)}
                                    </div>

                                    <div
                                        id={'dt' + text.id} onClick={() => this.deleteText(text)}
                                        className={`${styles['handler']} ${styles['delete-text']} ${styles['static-handler']} ${!this.controllersShown ? styles["control-hidden"] : ''}`}
                                    >
                                        {IconHelper.getIconElement(HtmlEntityTypes.TRASH_BIN)}
                                    </div>

                                </div>
                            })
                        }

                        {
                            (this.meme ? this.meme.getImages() : []).map((image: any, index) => {
                                return <div
                                    key={image.id}
                                    id={image.id}
                                    className={`${styles['image-container-parent']}`}
                                    style={{
                                        width: image.boundingRectangle.width,
                                        height: image.boundingRectangle.height,
                                        left: image.boundingRectangle.x,
                                        top: image.boundingRectangle.y,
                                    }}
                                >
                                    <div className={`${styles['image-container']}`} style={{ bottom: image.boundingRectangle.height }}>
                                        <div className={`${styles['image-handles']} ${!this.controllersShown ? styles["control-hidden"] : ''}`}>
                                            <div className={`${styles['image-actions']}`}>
                                                <div>
                                                    {
                                                        this.borderPropertyPanelShownForImage && this.getBorderPropertyPanelFor(image)
                                                    }
                                                    <button type="button" className="btn btn-info btn-sm" onClick={() => this.toggleBorderPropertyPanelFor(image)}
                                                    >
                                                        {
                                                            this.borderPropertyPanelShownForImage ?
                                                                IconHelper.getIconElement(HtmlEntityTypes.MINUS) :
                                                                IconHelper.getIconElement(HtmlEntityTypes.PLUS_BOLD)
                                                        } Space
                                                    </button>
                                                </div>
                                                <div>
                                                    {
                                                        this.addImagePanelShowForImage && this.getAddImagePanel(image)
                                                    }
                                                    {
                                                        index !== ((this.meme ? this.meme.getImages() : []).length - 1) && <button type="button"
                                                            className="btn btn-secondary btn-sm" onClick={() => this.moveImageDown(image)}>
                                                            {IconHelper.getIconElement(HtmlEntityTypes.ARROW_DOWN)}
                                                        </button>
                                                    }
                                                    <button type="button" className="btn btn-info btn-sm" onClick={() => this.toggleAddImagePanelFor(image)}>
                                                        {
                                                            this.addImagePanelShowForImage ?
                                                                IconHelper.getIconElement(HtmlEntityTypes.MINUS) :
                                                                IconHelper.getIconElement(HtmlEntityTypes.PLUS_BOLD)
                                                        }
                                                        Image
                                                    </button>
                                                    {
                                                        index !== 0 && <button type="button" className="btn btn-secondary btn-sm"
                                                            onClick={() => this.moveImageUp(image)}>
                                                            {IconHelper.getIconElement(HtmlEntityTypes.ARROW_UP)}
                                                        </button>
                                                    }

                                                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => this.deleteImage(image)}>
                                                        {IconHelper.getIconElement(HtmlEntityTypes.TRASH_BIN)}
                                                    </button>
                                                </div>
                                                <div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            })
                        }


                    </div>
                </div>
                <div className="hidden-xs hidden-sm hidden-md col-lg-1"></div>

                {
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-3">
                        {
                            this.features && <FeaturesTilesComponent features={this.features}></FeaturesTilesComponent>
                        }
                    </div>
                }
            </div>
        </div>
    }
}
